import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import {
  getFunctions,
  connectFunctionsEmulator,
  httpsCallable,
} from "firebase/functions";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getMessaging } from "firebase/messaging";

export const config = {
  apiKey: process.env.NX_FIREBASE_API_KEY,
  authDomain: process.env.NX_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NX_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NX_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NX_FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.NX_FIREBASE_APP_ID,
};

const app = initializeApp(config);

// auth
export const auth = getAuth();

// functions
export const functions = getFunctions(app);
functions.region = "europe-west2";

export const firebaseFunctions = {
  listUsers: httpsCallable(functions, "listUsers"),
  listSailors: httpsCallable(functions, "listSailors"),
  createNewSailor: httpsCallable(functions, "createNewSailor"),
  createNewUser: httpsCallable(functions, "createNewUser"),
  affordabilityCheck: httpsCallable(functions, "affordabilityCheck"),
  updateAdminPermissions: httpsCallable(functions, "updateAdminPermissions"),
};

// firestore
export const db = getFirestore();

export default app;

export const storage = getStorage();

if (process.env.NX_DEBUG_LOCALHOST === "true") {
  console.log("Using local functions emulator");
  connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
  connectFunctionsEmulator(functions, "localhost", 5001, {
    disableWarnings: true,
  });
  connectFirestoreEmulator(db, "localhost", 8081, { disableWarnings: true });
  connectStorageEmulator(storage, "localhost", 9199, { disableWarnings: true });
}

// messaging
export const messaging = getMessaging(app);
